<div *ngIf="isLoading" class="loader" [ngClass]="{ 'dialog-loader': isDialog }">
    <div class="progress-spinner">
        <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
    <div class="loader-message">
        <div class="message">{{ 'COMMON.LOADER.MESSAGE_LOADING' | translate }}</div>
        <div data-ut-loader-message>
            {{ message }}
        </div>
    </div>
</div>
